export class UserServiceResponse {
  public isSuccessful?: boolean;
  public message?: string;
  public errorMessage?: string;
}
